import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import { MainButton, CancelButton } from 'components/button'
import { localize } from 'helpers/translator'
import PropTypes from 'prop-types'

import styles from './nearpod_picker_bottom_bar.scss'

class NearpodPickerBottomBar extends PureComponent {
	render() {
		return (
			<div styleName={classNames({
				'btn-bar': true,
				'btn-bar--with-background': this.props.shouldShowBackground,
			})}>
				{this.props.cancelHandler &&
					<div styleName='cancel-btn'>
						<CancelButton
							autoFocus={true}
							focus={true}
							onClick={this.props.cancelHandler}
						>
							{this.props.cancelText}
						</CancelButton>
					</div>
				}
				<div styleName='save-btn'>
					<MainButton focus={true} onClick={this.props.saveHandler} disabled={!this.props.saveButtonEnabled}>{localize('global_save')}</MainButton>
				</div>
			</div>
		)
	}
}

NearpodPickerBottomBar.propTypes = {
	shouldShowBackground: PropTypes.bool,
	cancelHandler: PropTypes.func,
	saveHandler: PropTypes.func,
	saveButtonEnabled: PropTypes.bool,
	cancelText: PropTypes.string,
}

NearpodPickerBottomBar.defaultProps = {
	shouldShowBackground: true,
	saveButtonEnabled: false,
	saveHandler: () => {},
	cancelText: 'Cancel',
}

export default CSSModules(NearpodPickerBottomBar, styles, {allowMultiple: true})
